import React, { Component } from 'react';
import PropTypes from 'prop-types';

const canUseDOM = !!(
  (typeof window !== 'undefined' &&
  window.document && window.document.createElement)
);

export const IntercomAPI = (...args) => {
  if (canUseDOM && window.Intercom) {
    window.Intercom.apply(null, args);
  } else {
    console.warn('Intercom not initialized yet');
  }
};

export default class Intercom extends Component {
  static propTypes = {
    appID: PropTypes.string,
    app_id: PropTypes.string
  };

  static displayName = 'Intercom';

  constructor(props) {
    super(props);

    const {
      appID,
      ...otherProps
    } = props;

    if (!appID || !canUseDOM) {
      return;
    }

    const scriptIntercom = document.getElementById('welltory-intercom');
    const currentThis = this;
    if (!scriptIntercom) {
      (function(w, d, id, s, x) {
        s = d.createElement('script');
        s.async = 1;
        s.src = 'https://widget.intercom.io/widget/' + id;
        s.id = 'welltory-intercom';
        s.onload = currentThis.onLoadIntercom;
        d.body.appendChild(s);
      })(window, document, appID);
    }
    else {
			this.onBootIntercom();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      appID,
      ...otherProps
    } = nextProps;

    if (!canUseDOM) return;

    window.intercomSettings = { ...otherProps, app_id: appID };
    if (window.Intercom) {
      window.Intercom('update', otherProps);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.Intercom) return false;
    window.Intercom('shutdown');
  }

  onLoadIntercom = () => {
  	function i() {
      i.c(arguments);
    }
    i.q = [];
    i.c = function(args) {
        i.q.push(args);
    };
    window.Intercom = i;

    this.onBootIntercom();
  };

  onBootIntercom = () => {
  	const {
      appID,
      ...otherProps
    } = this.props;

    window.intercomSettings = { ...otherProps, app_id: appID };
    if (window.Intercom) {
      setTimeout(() => window.Intercom('boot', otherProps), 2000);
    }
  };

  render() {
    return false;
  }
}
